export class ContactMenu {
  constructor() {
    // Cache DOM elements
    this.wrapper = $('.contact-btn-wrapper');
    this.menu = $('.contact-btn_menu');
    this.menuOpen = $('#menu-open');
    this.menuClose = $('#menu-close');
    this.contactMail = $('.contact_options_mail');
    
    // State management
    this.isTransitioning = false;
    this.mouseLeaveTimeout = null;
    
    // Bind event listeners
    this.initializeEventListeners();
  }

  initializeEventListeners() {
    // Mouse events on wrapper
    this.wrapper
      .on('mouseenter', () => {
        clearTimeout(this.mouseLeaveTimeout);
        this.showMenu();
      })
      .on('mouseleave', (e) => {
        // Clear any existing timeout
        clearTimeout(this.mouseLeaveTimeout);
        
        // Set a small delay before closing
        this.mouseLeaveTimeout = setTimeout(() => {
          // Only hide if the mouse isn't over the wrapper
          if (!this.wrapper.is(':hover')) {
            this.hideMenu();
          }
        }, 300);
      });

    // Click events
    this.menuOpen.on('click', () => this.showMenu());
    this.menuClose.on('click', () => this.hideMenu());
    this.contactMail.on('click', () => this.hideMenu());
    
    // Handle clicks outside the menu
    $(document.body).on('click', (e) => this.handleBodyClick(e));
  }

  showMenu() {
    if (this.isTransitioning || this.menuClose.css('display') === 'flex') {
      return;
    }

    this.menu.css('transform', 'translateY(0)');
    this.menuOpen.css('display', 'none');
    this.menuClose.css('display', 'flex');
  }

  hideMenu() {
    if (this.isTransitioning || this.menuOpen.css('display') === 'flex') {
      return;
    }

    this.menu.css('transform', 'translateY(200%)');
    this.menuClose.css('display', 'none');
    this.menuOpen.css('display', 'flex');

    // Prevent menu flicker during transition
    this.isTransitioning = true;
    setTimeout(() => {
      this.isTransitioning = false;
    }, 300); // Match your CSS transition duration
  }

  handleBodyClick(e) {
    if (!this.wrapper.has(e.target).length) {
      this.hideMenu();
    }
  }
}
